import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import TransitionsModal from '../Modal';
import CustomBreadcrumbs from '../Breadcrumb';
import { useDispatch } from 'react-redux';
import { getAllPV_plans } from '../../ReduxStore/CreatePlanSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const PVRescheduleplan = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Physical Verification', href: '/physical-verification' },
    ];
    const plans = JSON.parse(localStorage.getItem("PVplans")) || [];
    console.log("plans", plans);
    const [open, setOpen] = React.useState(false);
    const [plan, setPlan] = useState();
    const [allplans, setAllplans] = useState();
    const [loading, setLoading] = useState(true);
    const Role = localStorage.getItem("userRole");

    const planHandler = (plan) => {
        if (Role === 'admin' || Role === 'supplier') {
            setOpen(true)
            setPlan(plan);
        } else {
            toast.info("You don't have access to do this activity!")
        }
    }

    const handleClose = () => {
        setOpen(false);
    };

    const getAllplans = async () => {
        try {
            const action = dispatch(getAllPV_plans());
            const res = await action.unwrap();
            setAllplans(res.result.pv_plan);
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await getAllplans();
            setLoading(false);
        };
        fetchData();
    }, [])

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Reschedule Plan
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Reschedule Plan" />
                </Box>
                <Box>
                    {allplans && allplans.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <Typography variant="h5">No Plan created</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={3}>
                            {allplans && allplans.map((plan, index) => (
                                <Grid item className='PM' xs={12} sm={3} key={index}>
                                    <div className='card' onClick={() => { planHandler(plan) }}
                                    >
                                        {/* Conditionally render the submitted batch if the status is approval-pending */}
                                        {plan.reschedule_date && (
                                            <div style={{
                                                backgroundColor: 'brown',
                                                color: 'white',
                                                padding: '5px',
                                                borderRadius: '5px',
                                                marginBottom: '10px'
                                            }}>
                                                Rescheduled
                                            </div>
                                        )}
                                        <p>Supplier Name:{plan.vendor_details.vendor_description
                                        }</p>
                                        <p>Vendor Code: {plan.vendor_details.vendor}</p>
                                        <p>Vendor Location: {plan.vendor_details.location}</p>
                                        <h4>Physical Verification</h4>
                                        <p>Frequency: {plan.frequency}</p>
                                        <p>{plan.original_date}</p>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    )
                    }

                    {/* {plans.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <Typography variant="h5">No Plan created</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={3}>
                            {plans && plans.map((plan, index) => (
                                <Grid item className='PM' xs={3} key={index}>
                                    <div className='card' onClick={() => { planHandler(plan) }}
                                    >
                                        <p>Supplier Name:{plan.SupplierName
                                        }</p>
                                        <p>Vendor Code: {plan.vendorCode}</p>
                                        <p>Vendor Location: {plan.vendorlocation}</p>
                                        <h4>Physical Verification</h4>
                                        <p>Frequency: {plan.frequency}</p>
                                        <p>{plan.startDate}</p>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    )
                    } */}

                </Box>
                <TransitionsModal open={open} handleClose={handleClose} selectedPlan={plan} plan="Rescheduleplan" />
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default PVRescheduleplan;
